<script setup lang="ts">
import { colors } from '~/utils';

interface Props {
  title: string;
  height: number;
  seriesName: string;
  data: Record<string, number>;
}

const props = defineProps<Props>();

const sorted = Object.entries(props.data).sort(([, a], [, b]) => b - a);
const keys = sorted.map(([key]) => key);
const values = sorted.map(([, value]) => value);

const chartAttrs = {
  series: [
    {
      name: props.seriesName,
      data: values,
    },
  ],
  options: {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    xaxis: {
      categories: keys,
      labels: {
        show: false,
      },
    },
  },
};
</script>
<template>
  <a-card :title="props.title">
    <apexchart
      type="bar"
      :height="props.height"
      v-bind="chartAttrs"
    ></apexchart>
  </a-card>
</template>
